/*
* XNGAGE CONFIDENTIAL
* __________________________
*
* Copyright (C) 2023 Xngage - All Rights Reserved
*
* All code or information contained herein is, and remains the
* property of Xngage LLC and its customers.  The intellectual
* and technical concepts contained are proprietary to Xngage LLC
* and may be covered by U.S. and Foreign Patents, patents in
* process, and are protected by trade secret or copyright law.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Xngage LLC.
*/
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,

} from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        userName: string;
        email: string;
        firstName: string;
        lastName: string;
        role: string;
        approver: string;
    } & HasOnSuccess &
    HasOnError<string>,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;

export const XngPopulateApiParameter: HandlerType = props => {
    // removing equiresActivation: true to prevent password from being generated
    props.apiParameter = {
        account: {
            ...props.parameter,
        },
    };

    const useEmailAsUserName = getSettingsCollection(props.getState()).accountSettings.useEmailAsUserName;
    if (useEmailAsUserName) {
        props.apiParameter.account.userName = props.apiParameter.account.email;
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
